module.exports = __webpack_public_path__ + "img/w-profile-collection.681e7a6a.svg";